// extracted by mini-css-extract-plugin
module.exports = {"actor":"dropdownAutoComplete_actor__2y6e4","isOpen":"dropdownAutoComplete_isOpen__1LHrB"};